import { z } from 'zod';

import {
  OptionalBaseEncounterParamsFormFields,
  OptionalBaseEncounterParamsSchema,
} from './Encounters';
import { BlockValueTemplateField } from '../../../../ConfigFields/CodeMirror/FlowTemplate';
import { OptionalStringSchema, RequiredStringSchema } from '../common';

export const OrderJobParamsSchema = OptionalBaseEncounterParamsSchema.merge(
  z.object({
    patientOrderId: OptionalStringSchema,
    patientOrderEhrScheduled: OptionalStringSchema,
    fin: OptionalStringSchema,
    ehrReferenceValue: OptionalStringSchema,
    patientEhrId: RequiredStringSchema,
    ehrInformationId: OptionalStringSchema,
  })
);

export function OrderJobParamsFormFields() {
  return (
    <>
      <BlockValueTemplateField
        fieldName="config.payload.patientOrderId"
        label="Patient Order Id"
        helperText="Enter the reference to the Patient Order Id e.g. `{{patient.data.patientOrderId}}`"
        placeholder="e.g. {{data.patientOrderId}}`"
      />
      <BlockValueTemplateField
        fieldName="config.payload.patientOrderEhrScheduled"
        label="Patient Order Ehr Scheduled"
        helperText="Enter the reference to the Patient Order Ehr Scheduled e.g. `{{patient.data.patientOrderEhrScheduled}}`"
        placeholder="e.g. {{data.patientOrderEhrScheduled}}`"
      />
      <BlockValueTemplateField
        fieldName="config.payload.fin"
        label="Fin"
        helperText="Enter the reference to the Fin e.g. `{{patient.data.fin}}`"
        placeholder="e.g. {{data.fin}}`"
      />
      <BlockValueTemplateField
        fieldName="config.payload.ehrReferenceValue"
        label="Ehr Reference Value"
        helperText="Enter the reference to the Ehr Reference Value e.g. `{{patient.data.ehrReferenceValue}}`"
        placeholder="e.g. {{data.ehrReferenceValue}}`"
      />
      <BlockValueTemplateField
        fieldName="config.payload.patientEhrId"
        label="Patient Ehr Id"
        helperText="Enter the reference to the Patient Ehr Id e.g. `{{patient.data.patientEhrId}}`"
        placeholder="e.g. {{data.patientEhrId}}`"
      />
      <BlockValueTemplateField
        fieldName="config.payload.ehrInformationId"
        label="Ehr Information Id"
        helperText="Enter the reference to the Ehr Information Id e.g. `{{patient.data.ehrInformationId}}`"
        placeholder="e.g. {{data.ehrInformationId}}`"
      />
      <OptionalBaseEncounterParamsFormFields />
    </>
  );
}
